'use client';

import { Button } from "@/components/ui/button";
import { promptsArray } from "./prompts";
import { CaretRightIcon, ChatBubbleIcon } from "@radix-ui/react-icons";


import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface BtnPromptsProps {
    sendMessage: (content: string) => void;
}

export default function BtnPrompts({ sendMessage }: BtnPromptsProps) {

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        if (value) {
            sendMessage(value);
            // Reset the select value so the same prompt can be selected again if needed
            e.target.value = "";
        }
    };

    return (
        <>
            <div className="relative md:hidden">
                <Button variant="ghost" size="icon" asChild>
                    <div className="relative">
                        <ChatBubbleIcon />
                        <select
                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                            onChange={handleChange}
                            value=""
                            aria-label="Select a prompt"
                        >
                            <option value="" disabled>Select a prompt</option>
                            {promptsArray.map((prompt, index) => (
                                <option key={index} value={prompt}>
                                    {prompt}
                                </option>
                            ))}
                        </select>
                    </div>
                </Button>
            </div>

            <div className="hidden md:block">
                <DropdownMenu>
                    <DropdownMenuTrigger className="flex items-center gap-2 cursor-pointer hover:text-foreground transition-colors outline-none">
                        <ChatBubbleIcon />Quick Prompts
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="start" className="mt-4 z-1001 text-muted-foreground bg-background border border-border w-80">
                        {promptsArray.map((prompt, index) => {
                            if (prompt === "-") return <DropdownMenuSeparator key={index} />;
                            return <DropdownMenuItem key={index} onClick={() => sendMessage(prompt)}>
                                <CaretRightIcon /> {prompt}
                            </DropdownMenuItem>;
                        })}
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
        </>
    );
}

